import React from 'react';
import { Seal } from '@sbt-web/ui';
import classes from './index.module.scss.js';

const ProSeals = () => (React.createElement("div", { className: classes.seals },
    React.createElement(Seal, null, "Venditore verificato"),
    React.createElement(Seal, null, "Reso entro 14 giorni")));

export { ProSeals };
//# sourceMappingURL=index.js.map
